import { forwardRef } from 'react';

import type { CSSProperties, PropsWithChildren, Ref } from 'react';

export interface FlexProps extends PropsWithChildren {
  id?: string;

  className?: string;
  direction?: CSSProperties['flexDirection'];
  flex?: CSSProperties['flex'];
  gap?: CSSProperties['gap'];
  height?: CSSProperties['height'];
  inline?: boolean;
  items?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
  self?: CSSProperties['alignSelf'];
  shrink?: CSSProperties['flexShrink'];

  style?: CSSProperties;
  width?: CSSProperties['width'];
  wrap?: CSSProperties['flexWrap'];
}

function Flex(
  {
    children,
    className,
    style,
    direction,
    flex,
    gap,
    inline,
    shrink,
    wrap,
    items,
    justify,
    self,
    id,
    width,
    height,
  }: FlexProps,
  ref?: Ref<HTMLDivElement>,
) {
  return (
    <div
      id={id}
      className={className}
      ref={ref}
      style={{
        alignItems: items,
        alignSelf: self,
        display: inline ? 'inline-flex' : 'flex',
        flex,
        flexDirection: direction,
        flexShrink: shrink,
        flexWrap: wrap,
        gap,
        height,
        justifyContent: justify,
        width,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default forwardRef(Flex);
